import React from 'react';
import { useMenuHook } from './Hooks';
import MenuComponent from './Component';

const Menu = () => {
  return <MenuComponent {...useMenuHook()} />
}
export default Menu;
